<div class="input-group inline-group mb-2">
	<label for="basicSalary" class="col-3 col-form-label me-2">Podstawa: </label>
	<div class="col-3 me-2">
		<input
			type="number"
			name="basicSalary"
			class="form-control"
			id="basicSalary"
			[(ngModel)]="data.basicSalary"
			[disabled]="!editable"
		/>
	</div>
	<label for="sumMonth" class="col-2 col-form-label me-2">Suma miesięczna PLN: </label>
	<div class="col-2">
		<input
			type="text"
			name="sumMonth"
			class="form-control"
			id="sumMonth"
			[value]="summary.sumMonth | numberToDecimalStr"
			disabled
			readonly
		/>
	</div>
</div>
<div class="input-group inline-group mb-2">
	<label for="diets" class="col-3 col-form-label me-2">Dieta: </label>
	<div class="col-3 me-2">
		<input
			type="text"
			name="diets"
			class="form-control"
			id="diets"
			[value]="summary.diets | numberToDecimalStr"
			disabled
			readonly
		/>
	</div>
	<label for="sumMonthEuro" class="col-2 col-form-label me-2">Suma miesięczna EUR: </label>
	<div class="col-2">
		<input
			type="text"
			name="sumMonthEuro"
			class="form-control"
			id="sumMonthEuro"
			[value]="summary.sumMonthEuro | numberToDecimalStr"
			disabled
			readonly
		/>
	</div>
</div>
<div class="input-group inline-group mb-2">
	<label for="mobility" class="col-3 col-form-label me-2">Pakiet mobilności: </label>
	<div class="col-3">
		<input
			type="text"
			name="mobility"
			class="form-control"
			id="mobility"
			[value]="summary.mobility | numberToDecimalStr"
			disabled
			readonly
		/>
	</div>
</div>
<div class="input-group inline-group mb-2">
	<label for="rates" class="col-3 col-form-label me-2">Wgl stawek: </label>
	<div class="col-3 me-2">
		<input
			type="text"
			class="form-control"
			id="rates"
			name="rates"
			[value]="summary.rates | numberToDecimalStr"
			disabled
			readonly
		/>
	</div>
	<div class="input-group-append">
		<div class="btn btn-outline-secondary" (click)="infoRatesOpen('rates')">
			<i class="fa fa-info-circle"></i>
		</div>
	</div>
	<label class="col-3 ms-2">Dni które są nieliczone : {{ caluclateCount }}</label>
</div>
<div class="input-group inline-group mb-2">
	<label for="benefits" class="col-3 col-form-label me-2">Dodatki: </label>
	<div class="col-3 me-2">
		<input
			type="text"
			name="benefits"
			class="form-control"
			id="benefits"
			[value]="summary.benefits | numberToDecimalStr"
			disabled
			readonly
		/>
	</div>
	<div class="input-group-append">
		<div class="btn btn-outline-secondary" (click)="infoRatesOpen('bonusPositive')">
			<i class="fa fa-info-circle"></i>
		</div>
	</div>
	<span *ngIf="showDuplicates" class="col-3 ms-2">{{ showDuplicates }} </span>
</div>
<div class="input-group inline-group mb-2">
	<label for="deductions" class="col-3 col-form-label me-2">Potrącenia: </label>
	<div class="col-3 me-2">
		<input
			type="text"
			class="form-control"
			id="deductions"
			name="deductions"
			[value]="summary.deductions | numberToDecimalStr"
			disabled
			readonly
		/>
	</div>
	<div class="input-group-append">
		<div class="btn btn-outline-secondary" (click)="infoRatesOpen('bonusNegative')">
			<i class="fa fa-info-circle"></i>
		</div>
	</div>
</div>
<div class="input-group inline-group mb-2">
	<label for="transfer" class="col-3 col-form-label me-2">Przelew: </label>
	<div class="col-3">
		<input
			type="text"
			class="form-control"
			id="transfer"
			name="transfer"
			[value]="summary.transfer | numberToDecimalStr"
			disabled
			readonly
		/>
	</div>
</div>
<div class="input-group inline-group mb-2">
	<label for="cash" class="col-3 col-form-label me-2">Gotówka PLN: </label>
	<div class="col-3">
		<input
			type="number"
			class="form-control"
			id="cash"
			name="cash"
			[value]="summary.cash | numberToDecimalStr"
			disabled
			readonly
		/>
	</div>
</div>
<div class="input-group inline-group mb-2">
	<label for="cash" class="col-3 col-form-label me-2">Gotówka EUR: </label>
	<div class="col-3">
		<input
			type="text"
			class="form-control"
			id="cashEuro"
			name="cashEuro"
			[value]="summary.cashEuro | numberToDecimalStr"
			disabled
			readonly
		/>
	</div>
</div>
<div class="input-group inline-group mb-2 mt-2">
	<div class="col-3 text-end me-2">
		<button
			type="button"
			class="btn"
			name="confirmedDays"
			[ngClass]="{
				'btn-success': data.confirmedDays,
				'btn-outline-danger': !data.confirmedDays,
			}"
			(click)="confirmedSalary(!data.confirmedDays)"
			[disabled]="editable"
		>
			Zatwierdź
		</button>
	</div>
	<div>
		{{ lastUserConfirmed?.userName }}<br />
		{{ lastUserConfirmed?.date }}
	</div>
</div>
<div class="input-group inline-group mb-2">
	<label for="salary" class="col-3 col-form-label me-2">Uwagi do rozliczeń: </label>
	<div class="col-3">
		<textarea
			type="text"
			class="form-control"
			id="salary"
			name="salary"
			[(ngModel)]="driver.salary"
			rows="4"
			[disabled]="!editable"
			readonly
		></textarea>
	</div>
</div>
<div class="input-group inline-group mb-2">
	<label for="comment" class="col-3 col-form-label me-2">Uwagi do wypłaty: </label>
	<div class="col-3">
		<textarea
			type="text"
			class="form-control"
			name="comment"
			id="comment"
			[(ngModel)]="data.comment"
			rows="4"
			[disabled]="!editable"
		></textarea>
	</div>
</div>
<div class="input-group inline-group mb-2">
	<label for="payment" class="col-2 col-form-label me-2">Do wypłaty PLN: </label>
	<div class="col-3 me-2">
		<input
			type="text"
			class="form-control"
			id="payments"
			name="payments"
			[value]="summary.payments | numberToDecimalStr"
			disabled
			readonly
		/>
	</div>
</div>

<div class="input-group inline-group mb-2">
	<label for="paymentsEuro" class="col-2 col-form-label me-2">Do wypłaty EURO: </label>
	<div class="col-3 me-2">
		<input
			type="text"
			class="form-control"
			id="paymentsEuro"
			name="paymentsEuro"
			[value]="summary.paymentsEuro | numberToDecimalStr"
			disabled
			readonly
		/>
	</div>
</div>

<div class="col-3">
	<fieldset [disabled]="editable">
		<div type="number" class="btn btn-primary form-control" id="salary" (click)="paymentsModal()">Wypłaty</div>
	</fieldset>
</div>

<app-drivers-salary-payments
	[driverId]="driver"
	[selectedMonth]="salaryData"
	[paymentsData]="sendData"
	(calculate)="getDriverSalarySummary()"
></app-drivers-salary-payments>

<app-drivers-modal-info [driverSalarySummary]="driverSalarySummary()"></app-drivers-modal-info>
